export enum PassengerEnrollmentStatus {
    DISABLED = 'DISABLED',
    UNREGISTERED = 'UNREGISTERED',
    REGISTERED = 'REGISTERED',
    ACCEPTED = 'ACCEPTED',
}
